// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import {
  RegistrationTokenValidationModel,
  RegistrationValidationStages,
  TokenValidationErrorTypes,
} from '../../../models';
import { AppService } from '../app.service';
import { OidcService } from '../account/oidc.service';
import { RegistrationValidationBaseService } from './registrationvalidation-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class RegistrationValidationMockService extends RegistrationValidationBaseService {
  constructor(appService: AppService, oidcService: OidcService) {
    super(appService, oidcService);
  }

  validateRegistrationToken(id: string): void {
    of(id)
      .pipe(delay(5000))
      .subscribe((result) => {
        if (result === 'error') {
          this._validationStage$.next(RegistrationValidationStages.tokenError);
          this._validation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderUnexpected',
              detailedMessage: 'commonUnexpectedError',
            },
          } as RegistrationTokenValidationModel);
          return;
        }
        this._authenticateFromOtac('');
      });
  }
}
